<template>
  <div>
    <!-- DESKTOP -->
    <VContainer id="bg-description" fluid class="align-start d-none d-lg-block">
      <VRow>
        <VCol cols="12" md="8" xl="6">
          <VCard class="elevation-0 ml-16 mb-10" color="transparent">
            <VCardText class="font-weight-bold text-h4 text-primary" style="white-space: pre-line;">
              {{ $t('REPORT_LAKE_DESCRIPTION.first_text') }}
            </VCardText>
          </VCard>
        </VCol>

        <VCol cols="12">
          <VCard class="elevation-0" color="transparent">
            <VCardText class="ml-16 mt-16 font-weight-bold text-h2 text-primary">
              {{ $t('REPORT_LAKE_DESCRIPTION.second_title') }}
            </VCardText>
          </VCard>
        </VCol>

        <VCol cols="12" md="5">
          <VCard class="elevation-0" color="transparent">
            <VCardText class="font-weight-medium ml-16 text-h4 text-primary">
              {{ $t('REPORT_LAKE_DESCRIPTION.second_text') }}
            </VCardText>
          </VCard>
        </VCol>
      </VRow>

      <VRow class="d-none d-lg-block">
        <VCol cols="12">
          <div class="d-flex justify-space-around mb-6">
            <VCard class="pa-2" elevation="0" color="transparent">
              <VCardText class="d-flex justify-center">
                <VImg
                  max-width="50px"
                  :src="schedule"
                  :lazy-src="schedule"
                />
              </VCardText>
              <VCardText class="text-center text-white text-h6 font-weight-bold" style="white-space: pre-line;">
                {{ $t('REPORT_LAKE_DESCRIPTION.icon1') }}
              </VCardText>
            </VCard>

            <VCard class="pa-2" elevation="0" color="transparent">
              <VCardText class="d-flex justify-center">
                <VImg
                  max-width="50px"
                  :src="graph"
                  :lazy-src="graph"
                />
              </VCardText>
              <VCardText class="text-center text-white text-h6 font-weight-bold" style="white-space: pre-line;">
                {{ $t('REPORT_LAKE_DESCRIPTION.icon2') }}
              </VCardText>
            </VCard>

            <VCard class="pa-2" elevation="0" color="transparent">
              <VCardText class="d-flex justify-center">
                <VImg
                  max-width="50px"
                  :src="hierarchic"
                  :lazy-src="hierarchic"
                />
              </VCardText>
              <VCardText class="text-center text-white text-h6 font-weight-bold" style="white-space: pre-line;">
                {{ $t('REPORT_LAKE_DESCRIPTION.icon3') }}
              </VCardText>
            </VCard>

            <VCard class="pa-2" elevation="0" color="transparent">
              <VCardText class="d-flex justify-center">
                <VImg
                  max-width="50px"
                  :src="locker"
                  :lazy-src="locker"
                />
              </VCardText>
              <VCardText class="text-center text-white text-h6 font-weight-bold" style="white-space: pre-line;">
                {{ $t('REPORT_LAKE_DESCRIPTION.icon4') }}
              </VCardText>
            </VCard>

            <VCard class="pa-2" elevation="0" color="transparent">
              <VCardText class="d-flex justify-center">
                <VImg
                  max-width="50px"
                  :src="continuous"
                  :lazy-src="continuous"
                />
              </VCardText>
              <VCardText class="text-center text-white text-h6 font-weight-bold" style="white-space: pre-line;">
                {{ $t('REPORT_LAKE_DESCRIPTION.icon5') }}
              </VCardText>
            </VCard>

            <VCard class="pa-2" elevation="0" color="transparent">
              <VCardText class="d-flex justify-center">
                <VImg
                  max-width="50px"
                  :src="balloon"
                  :lazy-src="balloon"
                />
              </VCardText>
              <VCardText class="text-center text-white text-h6 font-weight-bold" style="white-space: pre-line;">
                {{ $t('REPORT_LAKE_DESCRIPTION.icon6') }}
              </VCardText>
            </VCard>
          </div>
        </VCol>
      </VRow>
    </VContainer>

    <!-- MOBILE -->
    <VContainer id="bg-description" fluid class="align-start d-md-none">
      <VRow>
        <VCol cols="12" md="8" xl="6">
          <VCard class="elevation-0" color="transparent">
            <VCardText class="font-weight-bold text-h6 text-primary text-center" style="white-space: pre-line;">
              {{ $t('REPORT_LAKE_DESCRIPTION.first_text') }}
            </VCardText>
          </VCard>
        </VCol>

        <VCol cols="12">
          <VCard class="elevation-0" color="rgba(255,255,255,.5)">
            <VCardText class="text-center mt-16 font-weight-bold text-h4 text-primary">
              {{ $t('REPORT_LAKE_DESCRIPTION.second_title') }}
            </VCardText>
            <VCardText class="font-weight-medium text-h6 text-primary text-center">
              {{ $t('REPORT_LAKE_DESCRIPTION.second_text') }}
            </VCardText>

            <VCardText>
              <VCard class="pa-2" elevation="0" color="transparent">
                <VCardText class="d-flex justify-center">
                  <VImg
                    max-width="50px"
                    :src="schedule"
                    :lazy-src="schedule"
                  />
                </VCardText>
                <VCardText class="text-center text-primary text-h6 font-weight-bold" style="white-space: pre-line;">
                  {{ $t('REPORT_LAKE_DESCRIPTION.icon1') }}
                </VCardText>
              </VCard>

              <VCard class="pa-2" elevation="0" color="transparent">
                <VCardText class="d-flex justify-center">
                  <VImg
                    max-width="50px"
                    :src="graph"
                    :lazy-src="graph"
                  />
                </VCardText>
                <VCardText class="text-center text-primary text-h6 font-weight-bold" style="white-space: pre-line;">
                  {{ $t('REPORT_LAKE_DESCRIPTION.icon2') }}
                </VCardText>
              </VCard>

              <VCard class="pa-2" elevation="0" color="transparent">
                <VCardText class="d-flex justify-center">
                  <VImg
                    max-width="50px"
                    :src="hierarchic"
                    :lazy-src="hierarchic"
                  />
                </VCardText>
                <VCardText class="text-center text-primary text-h6 font-weight-bold" style="white-space: pre-line;">
                  {{ $t('REPORT_LAKE_DESCRIPTION.icon3') }}
                </VCardText>
              </VCard>

              <VCard class="pa-2" elevation="0" color="transparent">
                <VCardText class="d-flex justify-center">
                  <VImg
                    max-width="50px"
                    :src="locker"
                    :lazy-src="locker"
                  />
                </VCardText>
                <VCardText class="text-center text-primary text-h6 font-weight-bold" style="white-space: pre-line;">
                  {{ $t('REPORT_LAKE_DESCRIPTION.icon4') }}
                </VCardText>
              </VCard>

              <VCard class="pa-2" elevation="0" color="transparent">
                <VCardText class="d-flex justify-center">
                  <VImg
                    max-width="50px"
                    :src="continuous"
                    :lazy-src="continuous"
                  />
                </VCardText>
                <VCardText class="text-center text-primary text-h6 font-weight-bold" style="white-space: pre-line;">
                  {{ $t('REPORT_LAKE_DESCRIPTION.icon5') }}
                </VCardText>
              </VCard>

              <VCard class="pa-2" elevation="0" color="transparent">
                <VCardText class="d-flex justify-center">
                  <VImg
                    max-width="50px"
                    :src="balloon"
                    :lazy-src="balloon"
                  />
                </VCardText>
                <VCardText class="text-center text-primary text-h6 font-weight-bold" style="white-space: pre-line;">
                  {{ $t('REPORT_LAKE_DESCRIPTION.icon6') }}
                </VCardText>
              </VCard>
            </VCardText>
          </VCard>
        </VCol>
      </VRow>
    </VContainer>
  </div>
</template>

<script>
import continuous from '@/assets/icons/icons/vector/continuous.png'
import schedule from '@/assets/icons/icons/vector/schedule.png'
import graph from '@/assets/icons/icons/vector/graph.png'
import hierarchic from '@/assets/icons/icons/vector/hierarchic.png'
import locker from '@/assets/icons/icons/vector/locker.png'
import balloon from '@/assets/icons/icons/vector/balloon.png'

export default {
  name: 'ReportLakeDescription',
  data(){
    return{
        continuous,
        schedule,
        graph,
        hierarchic,
        locker,
        balloon
    }
  }
}
</script>

<style>
body #bg-description{
  background: rgb(255, 255, 255) url("../assets/imgs/background_grua.jpg");
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}
</style>
